<app-breadcrumb [title]="'Allotment Process'"></app-breadcrumb>
<div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="card mb-3">
                <div class="card-header">Allotment Process</div>
                <div class="col-auto ml-auto">
                    <select class="form-select mb-2 mr-sm-2" [(ngModel)]="selectedPhase" (change)="onPhaseChange($event)">
                        <option value="" selected>--SELECT PHASE--</option>
                        <option value="0">Both</option>
                        <option value="1">Phase-I</option>
                        <option value="2">Phase-II</option>
                    </select>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-3 form-check" *ngFor="let item of designations">
                            <input type="checkbox" class="form-check-input"
                                (change)="changeDesignation($event.target.checked, item.value)"
                                [checked]="isDesignationChecked(item.value)" [attr.id]="'des' + item.value">
                            <label class="form-check-label" [attr.for]="'des' + item.value">
                                {{ item.text }}
                            </label>
                        </div>
                    </div>


                    <div class="my-3" *ngIf="(message$ | async);let message">
                        {{message}}
                    </div>

                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary rounded-0 mr-2" [disabled]="loading"
                            (click)="generateEmployeeMerit()" type="button">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="loading"></span>
                            Validation
                        </button>
                        <button class="btn btn-primary rounded-0 mr-2" [disabled]="loading"
                            (click)="processAllotment()" type="button">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="loading"></span>
                            Allotment
                        </button>
                        <button class="btn btn-primary rounded-0 mr-2" [disabled]="loading"
                            (click)="export()" type="button">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="loading"></span>
                            Excel
                        </button>
                        <button class="btn btn-primary rounded-0 mr-2" [disabled]="loading" 
                        (click)="downloadPdf()" type="button">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="loading"></span>Download PDF</button>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>